import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
import { SymbolType } from "../enum/SymbolType";
/*
 * SymbolWinData.ts
 */
export class SymbolWinData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.amount = this.data.getNumber(SlingoConstants.PROPERTY_AMOUNT);
            this.numberOfSymbols = this.data.getNumber(SlingoConstants.PROPERTY_NUMBER_OF_SYMBOLS);
            this.type = SymbolType.getType(this.data.getString(SlingoConstants.PROPERTY_TYPE));
        }
    }
    setAmount(value) {
        this.amount = value;
    }
    setNumberOfSymbols(value) {
        this.numberOfSymbols = value;
    }
    setType(value) {
        this.type = value;
    }
    getAmount() {
        return this.amount;
    }
    getNumberOfSymbols() {
        return this.numberOfSymbols;
    }
    getType() {
        return this.type;
    }
}
//# sourceMappingURL=SymbolWinData.js.map